import React, { useState, useEffect, useContext, Fragment } from 'react';

import UplmPendingList from './UplmPendingList';
import UplmList from './UplmList';

import { LoginContext } from '../../../hooks/context/LoginContext';


import imageCompression from "browser-image-compression";
import axios from 'axios';
import swal from 'sweetalert';


import { getApiUrl, axiosPost } from '../../../helpers/helperApp';

function Uplm(props){

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const { col, id, adjuntos, saveAdjuntos, adjuntosExistentes, saveAdjuntosExistentes, readonly, loading, estadoForm, traduction, dropzone } = props;

    // ***** States *****
    const [validacionesUplm, saveValidacionesUplm] = useState([]);
    const [totalSizeMB, saveTotalSizeMB] = useState(0);
    const [maxSizeMB, saveMaxSizeMB] = useState(0); 

    // ***** Context *****
    const { apiKey } = useContext(LoginContext);

    useEffect( () => {
        // ***** Carga inicial de validaciones *****
        if( validacionesUplm.length === 0 ){
            const data = new FormData(); 
            const validacion = apiKey();
            data.append("validacion", validacion);
            const getValidacionesUplm = async () => {
                await axios.post( getApiUrl(window.location.origin)+"/adj/getValidaciones", data)
                // await axiosPost(getApiUrl(window.location.origin)+"/adj/getValidaciones", data, source.token)
                .then( response => {
                    if( typeof response.data !== "string" ){
                        saveValidacionesUplm(response.data);
                    }
                    // else{
                    //     swal("Error", `${traduction.loadvalidationserror.title}`, "error");
                    // }
                })
                .catch( error => {
                    swal("Error", `${traduction.loadvalidationserror.title}`, "error");
                })
            }

            getValidacionesUplm();
        }

        return ( () => {
            saveValidacionesUplm([]); 
            // Token cancelación axios al desmontar componentes
            source.cancel();           
        })

    },[])

    // ***** Leer los archivos del input *****
    const handleFiles = async files => {
        await actionsFiles(files);
    }
    const handleDragEnter = async e => {
        e.preventDefault();
        e.stopPropagation();
        await actionsFiles(e.dataTransfer.files);
    };
    const handleDragLeave = async e => {
        e.preventDefault();
        e.stopPropagation();
        await actionsFiles(e.dataTransfer.files);
    };
    const handleDragOver = async e => {
        e.preventDefault();
        e.stopPropagation();
        await actionsFiles(e.dataTransfer.files);
    };
    const handleDrop = async e => {
        e.preventDefault();
        e.stopPropagation();
        await actionsFiles(e.dataTransfer.files);
    };

    const actionsFiles = async files => {

        const extensiones = validacionesUplm[0]["val"].split("|");
        const maxWidth = parseInt(validacionesUplm[1]["val"].split("x")[0]);
        const maxSize = parseFloat(validacionesUplm[2]["val"]); // MB totales permitidos        
        saveMaxSizeMB(maxSize);

        const optionsCompres = {          
            maxSizeMB: maxSize,
            maxWidthOrHeight: maxWidth,
            useWebWorker: false
        };

        let nuevosAdjuntos = [];
        let totalAcumulado = totalSizeMB; // tamaño actual acumulado

        for (let i = 0; i < files.length; i++) {

            const file = files[i];

            const duplicado = adjuntos.some(adj => adj.name === file.name);
            if (duplicado) {
                swal("Error", `${file.name} ${traduction.duplicate.title}`, "error");
                continue;
            }

            let valido = true;

            // Validación extensión
            if (!validateExtension(file, extensiones)) {
                swal("Error", `${file.name} ${traduction.errorextension.title}`, "error");
                valido = false;
            }

            if (!valido) continue;

            let processedFile = file;

            // Procesar imágenes
            if (file.type.startsWith("image/")) {
                try {
                    const fileResize = await imageCompression(file, optionsCompres);
                    processedFile = await blobToFile(fileResize, file);
                } catch (err) {
                    console.error("Error al comprimir imagen:", err);
                    continue;
                }
            } else {
                // Validación tamaño para PDFs u otros
                if (!validateSize(file)) {
                    swal("Error", `${file.name} ${traduction.errorsize.title} (${maxSize}Mb)`, "error");
                    continue;
                }
            }

            // *** CONTROL DE TAMAÑO TOTAL ***
            const sizeMB = processedFile.size / (1024 * 1024);

            if (totalAcumulado + sizeMB > maxSize) {
                swal("Error", `${traduction.errorlimit.title} (${maxSize}Mb).`, "error");
                break;
            }

            totalAcumulado += sizeMB;
            nuevosAdjuntos.push(processedFile);
        }

        // Guardamos adjuntos y el total acumulado
        if (nuevosAdjuntos.length > 0) {
            saveAdjuntos(prev => [...prev, ...nuevosAdjuntos]);
            saveTotalSizeMB(totalAcumulado);
        }

        document.querySelector(`#${id}`).value = "";
    };


    const validateExtension = (file, extensiones) => {
        let fileExtension = file["name"].split(".")[file["name"].split(".").length-1];
        const valido = extensiones.find(ext => fileExtension.toLowerCase() == ext.toLowerCase());
        return valido;
    }

    const validateSize = (file) => {
        let valido = true;
        let maxSize = validacionesUplm[2]["val"];

        if( (file["size"] / 1000) > (maxSize * 1000) ){
            valido = false;
        }

        return valido;
    }

    const blobToFile = (blob, file) => {
        blob.lastModifiedDate = file.lastModifiedDate;
        blob.name = file.name;
        return new File([blob], file.name,{type: "image/jpeg", lastModified: file.lastModifiedDate });     
    }

    return(
        <div className={"form-group col-md-"+col}>
                    <div className="containerCards">  
                        <UplmList 
                            id={id} 
                            adjuntosExistentes= { adjuntosExistentes } 
                            saveAdjuntosExistentes= { saveAdjuntosExistentes }
                            readonly={readonly}
                            loading={loading}
                            estadoForm={estadoForm}
                            traduction={traduction}
                        />
                    </div>
                    {
                        readonly !== "true" && readonly !== "readonly" && !loading && estadoForm !== "readonly" && estadoForm !== "disabled" 
                        ?
                        <div>                        
                            <div className="row fileupload-buttonbar">
                                <div className="col-lg-12">
                                    {
                                        dropzone != false
                                        ?
                                            <div className="well dropzone dropzone" 
                                                onDrop={e => handleDrop(e)}
                                                onDragOver={e => handleDragOver(e)}
                                                onDragEnter={e => handleDragEnter(e)}
                                                onDragLeave={e => handleDragLeave(e)}
                                            >
                                                <h3>{traduction.dropzone.title}</h3>
                                                <span><i className="fal fa-upload fa-2x"></i></span>
                                            </div>
                                        :
                                            null
                                    }
                                    
                                    <span className="btn btn-flat btn-success fileinput-button adj btn-block btn-lg " id="fileinput-buttonadj">
                                        <i className="far fa-paperclip mr-1" style={{transform : "rotate(-45deg)"}}></i>
                                        <span>{traduction.btnadd.title}</span>
                                        <input className="btn btn-success fileinput-button" id={id} type="file"  name={id+"[]"} multiple="multiple" onChange={ (e) => handleFiles(e.target.files) } />
                                    </span>
                                </div>
                            </div>
                            <div className="container-fluid" style={{marginTop:15}}>
                                {
                                    adjuntos.length > 0
                                    ?
                                        <Fragment>
                                            <div className="progress-container">
                                                <div
                                                    className="progress-fill"
                                                    style={{
                                                        height: "40px",
                                                    width: `${(totalSizeMB / maxSizeMB) * 100}%`,
                                                    backgroundColor: (totalSizeMB / maxSizeMB) * 100 < 50 ? "#4caf50" : (totalSizeMB / maxSizeMB) * 100 < 90 ?  "#ffc107" : "#dc3545"
                                                    }}
                                                >
                                                </div>
                                            </div>   
                                            <p className='text-center'>{totalSizeMB.toFixed(2)} MB / {maxSizeMB} MB</p>
                                        </Fragment>
                                    :
                                        null
                                }
                                <div className="containerCards">                                
                                        <UplmPendingList
                                            id={id}
                                            adjuntos={ adjuntos }
                                            saveAdjuntos= { saveAdjuntos }
                                            traduction={traduction}
                                            saveTotalSizeMB={saveTotalSizeMB}   
                                        />                                            
                                </div>
                            </div>
                        </div>
                        :
                        <div>                        
                            <div className="row fileupload-buttonbar" style={{display: "none"}}>
                                <div className="col-lg-12">
                                    <div className="well dropzone dropzone">
                                        <h3>{traduction.dropzone.title}</h3>
                                        <span><i className="fal fa-upload fa-2x"></i></span>
                                    </div>
                                    <span className="btn btn-flat btn-success fileinput-button adj btn-block btn-lg " id="fileinput-buttonadj">
                                        <i className="far fa-plus"></i>
                                        <span>{traduction.btnadd.title}</span>
                                        <input className="btn btn-success fileinput-button disable-click" id={id} type="file"  name={id+"[]"} multiple="multiple" />
                                    </span>
                                </div>
                            </div>
                            <div className="container-fluid" style={{marginTop:15}}>
                                <div className="containerCards">                                
                                        <UplmPendingList
                                            id={id}
                                            adjuntos={ adjuntos }
                                            saveAdjuntos= { saveAdjuntos } 
                                            traduction={traduction}  
                                        />                                            
                                </div>
                            </div>
                        </div>
                    }
                        
        </div>
    )
}

export default Uplm;